import React, { useEffect } from "react";
import { clearHotelDetBootstrapLoader } from "./clearHotelDetBootstrapLoader";
import "./HotelDetRouteFallback.scss";

const HOTEL_DETAILS_BOOTSTRAP_MESSAGE =
  "Loading hotel details and photos…";

const HotelDetRouteFallback = () => {
  // HTML bootstrap loader + this React fallback were stacking as 2 identical cards.
  useEffect(() => {
    clearHotelDetBootstrapLoader();
  }, []);

  return (
    <div
      className="hotel-det-route-fallback"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="hotel-det-route-fallback__card">
        <div className="hotel-det-route-fallback__spinner" aria-hidden="true" />
        <p className="hotel-det-route-fallback__title">
          {HOTEL_DETAILS_BOOTSTRAP_MESSAGE}
        </p>
        <p className="hotel-det-route-fallback__subtitle">
          Retrieving the latest room availability and pricing. This may take a few
          moments.
        </p>
      </div>
    </div>
  );
};

export default HotelDetRouteFallback;
